var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ep-list",
        { staticClass: "list" },
        [
          _vm._l(_vm.data, function (item, i) {
            return [
              _c(
                "ep-list-item",
                { key: i, staticClass: "item" },
                [
                  _c(
                    "ep-list-item-meta",
                    {
                      staticClass: "meta",
                      attrs: { slot: "meta" },
                      slot: "meta",
                    },
                    [
                      _c("avatar", {
                        staticClass: "avatar",
                        attrs: { slot: "avatar", src: item.avatar },
                        slot: "avatar",
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "title",
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        [
                          item.type === "通知"
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "white-space": "inherit" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.notifyForm.init(
                                        "read",
                                        item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "description",
                                    staticStyle: { height: "30px" },
                                    domProps: {
                                      innerHTML: _vm._s(item.description),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          item.type === "站内信"
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "white-space": "inherit" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.receivedMailDetail.init(
                                        item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "description",
                                    staticStyle: { height: "30px" },
                                    domProps: {
                                      innerHTML: _vm._s(item.description),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "datetime" }, [
                            _vm._v(_vm._s(item.datetime)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
          _c(
            "ep-list-item",
            { staticClass: "item" },
            [
              _c("ep-list-item-meta", [
                _c(
                  "div",
                  { attrs: { slot: "description" }, slot: "description" },
                  [
                    _c("router-link", { attrs: { to: _vm.url } }, [
                      _c(
                        "div",
                        {
                          staticClass: "description",
                          staticStyle: { "text-align": "center" },
                        },
                        [_vm._v("查看更多")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c("ReceivedMailDetail", { ref: "receivedMailDetail" }),
      _c("NotifyForm", { ref: "notifyForm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }